// CareerHeader.js
import React from 'react';
import styled from 'styled-components';
import careerVideo from '../../../assets/images/career/careerheader.mp4'; // Replace with your video path

const HeaderContainer = styled.header`
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;

  span.blue {
    color: #07b6f2;
  }
  span.dark {
    color:rgb(255, 255, 255);
  }
  
  @media (max-width: 768px) {
    min-height: 80vh;
  }

    @media (max-width: 576px) {
    min-height: 70vh;
  }
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
  z-index: -1;
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4); /* Dark overlay */
  z-index: 1;
`;

const HeaderText = styled.h1`
  font-size: 4em;
  z-index: 2;
 font-family: "Poppins", system-ui;
  font-weight: 700;
  font-style: normal;

  @media (max-width: 768px) {
    font-size: 3em;
  }

  @media (max-width: 576px) {
    font-size: 2em;
  }
`;

const ProductSalesBanner = () => {
  return (
    <HeaderContainer>
      <BackgroundVideo autoPlay loop muted>
        <source src={careerVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </BackgroundVideo>
      <Overlay />
      <HeaderText> <span className="dark">Siemens</span> Product Sales</HeaderText>
    </HeaderContainer>
  );
};

export default ProductSalesBanner;
